module.exports = __webpack_public_path__ + "media/images/map/car2-874e02f8d670ec004c943a9522614781.png";